
import React from 'react';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import ModernSidebar from '@/components/navigation/ModernSidebar';
import ModernHeader from '@/components/navigation/ModernHeader';
import BreadcrumbNavigation from '@/components/navigation/BreadcrumbNavigation';
import UniversalProgressHeader from '@/components/navigation/UniversalProgressHeader';
import KeyboardShortcuts from '@/components/navigation/KeyboardShortcuts';
import BottomNavigation from '@/components/mobile/BottomNavigation';
import { useIsMobile } from '@/hooks/use-mobile';

interface ModernLayoutProps {
  children: React.ReactNode;
}


const ModernLayout: React.FC<ModernLayoutProps> = ({ children }) => {
  const isMobile = useIsMobile();
  
  return (
    <SidebarProvider defaultOpen={true}>
      <KeyboardShortcuts />
      <div className="min-h-screen flex w-full bg-background">
        <ModernSidebar />
        
        <SidebarInset className="flex-1 flex flex-col">
          {/* Enhanced header with search */}
          <ModernHeader />
          
          {/* Universal progress header for course pages */}
          <UniversalProgressHeader />
          
          {/* Universal breadcrumb navigation */}
          <BreadcrumbNavigation />
          
          <main className={`flex-1 overflow-auto ${isMobile ? 'pb-20' : ''}`}>
            {children}
          </main>
        </SidebarInset>
      </div>
      
      {/* Bottom Navigation for mobile */}
      <BottomNavigation />
    </SidebarProvider>
  );
};

export default ModernLayout;
